// extracted by mini-css-extract-plugin
module.exports = {"yearWrapper":"TimelineCard_yearWrapper__6aZ6w","content":"TimelineCard_content__gcnNC"};